/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionCouponGroupDto } from '../../models/lp-inspection-coupon-group-dto';

export interface LpInspectionCouponGroupControllerFindById$Params {
  id: string;
}

export function lpInspectionCouponGroupControllerFindById(http: HttpClient, rootUrl: string, params: LpInspectionCouponGroupControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponGroupDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponGroupControllerFindById.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponGroupDto>;
    })
  );
}

lpInspectionCouponGroupControllerFindById.PATH = '/api/lp-inspection-coupon-group/{id}';
